import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getCategoryConfigs } from 'app/actions/BrowseActions';
import { TOP_LEVEL_CATEGORY_ID } from 'app/constants/AdminBrowseConstants';
import CategoryConfigsList from './CategoryConfigsList';

const CategoryConfigsListContainer = ({ languageKeys, onLanguageKeySelected, subdomain, topLevelCategoryId }) => {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    categoryConfigByLanguageKey: null,
    error: '',
    isFetching: false
  });

  useEffect(() => {
    let isMounted = true;

    setState(prevState => ({ ...prevState, error: '', isFetching: true }));
    dispatch(getCategoryConfigs(topLevelCategoryId))
      .then(fetchedCategoryConfigByLangaugeKey => {
        if (!isMounted) {
          return;
        }

        setState(prevState => {
          return {
            ...prevState,
            categoryConfigByLanguageKey: fetchedCategoryConfigByLangaugeKey
          };
        });
      })
      .catch(() => {
        if (!isMounted) {
          return;
        }

        setState(prevState => ({ ...prevState, error: 'Something went wrong. 😞' }));
      })
      .finally(() => {
        if (!isMounted) {
          return;
        }

        setState(prevState => ({ ...prevState, isFetching: false }));
      });

    return () => {
      isMounted = false;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subdomain, topLevelCategoryId]);

  const { categoryConfigByLanguageKey, error, isFetching } = state;

  return (
    <div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {isFetching && <p>Loading...</p>}
      {categoryConfigByLanguageKey && (
        <CategoryConfigsList
          categoryConfigByLanguageKey={categoryConfigByLanguageKey}
          languageKeys={languageKeys}
          onLanguageKeySelected={onLanguageKeySelected}
        />
      )}
    </div>
  );
};

CategoryConfigsListContainer.propTypes = {
  languageKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  onLanguageKeySelected: PropTypes.func.isRequired,
  subdomain: PropTypes.string.isRequired,
  topLevelCategoryId: PropTypes.oneOf(Object.values(TOP_LEVEL_CATEGORY_ID)).isRequired
};

export default CategoryConfigsListContainer;
